import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import type { LucideIcon } from './icons';
import { colors, radius, spacing, typography } from '../theme/tokens';

export type FeedbackStatus = 'success' | 'warning' | 'info';

export interface FeedbackSectionProps {
  status: FeedbackStatus;
  icon: LucideIcon;
  title: string;
  items: string[];
  testID?: string;
}

// Bloc de bilan teinté sémantiquement via les tokens existants (success/warning/info + *Soft).
const TINTS: Record<FeedbackStatus, { tint: string; accent: string }> = {
  success: { tint: colors.successSoft, accent: colors.success },
  warning: { tint: colors.warningSoft, accent: colors.warning },
  info: { tint: colors.infoSoft, accent: colors.info },
};

export function FeedbackSection({ status, icon: Icon, title, items, testID }: FeedbackSectionProps) {
  if (items.length === 0) return null;
  const { tint, accent } = TINTS[status];

  return (
    <View testID={testID} style={[styles.container, { backgroundColor: tint }]}>
      <View style={styles.header}>
        <Icon size={18} color={accent} strokeWidth={2} />
        <Text style={[styles.title, { color: accent }]}>{title}</Text>
      </View>
      {items.map((item, i) => (
        <View key={i} style={styles.row}>
          <View style={[styles.dot, { backgroundColor: accent }]} />
          <Text style={styles.text}>{item}</Text>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: { gap: spacing.sm, padding: spacing.lg, borderRadius: radius.lg },
  header: { flexDirection: 'row', alignItems: 'center', gap: spacing.sm },
  title: { fontSize: typography.h3.size, fontWeight: typography.h3.weight },
  row: { flexDirection: 'row', alignItems: 'flex-start', gap: spacing.sm },
  dot: { width: 6, height: 6, borderRadius: 3, marginTop: 7 },
  text: { flex: 1, fontSize: typography.body.size, color: colors.grey900, lineHeight: typography.body.lineHeight },
});
